import { t } from '@/i18n';
import { PresetTextField } from './PresetTextField';

interface ValueFormattingSectionProps {
  prefix?: string;
  suffix?: string;
  useMillions?: boolean;
  millionsFrom?: number | null;
  decimalPlaces?: number | null;
  onChange: (field: string, value: unknown) => void;
  testIdPrefix: string;
}

export function ValueFormattingSection({
  prefix = '',
  suffix = '',
  useMillions = false,
  millionsFrom,
  decimalPlaces,
  onChange,
  testIdPrefix,
}: ValueFormattingSectionProps) {
  const numberValue = (value: number | null | undefined): string =>
    value != null ? String(value) : '';

  const handleNumberChange = (field: string, raw: string) => {
    onChange(field, raw === '' ? null : Number(raw));
  };

  return (
    <div>
      <h6>{t('dashboard.widget.labeled_list.section.valueFormatting')}</h6>

      <PresetTextField
        label="dashboard.widget.indicator.field.prefix"
        value={prefix}
        onChange={(v) => onChange('prefix', v)}
        testId={`${testIdPrefix}-prefix`}
        testIdPrefix={`${testIdPrefix}-prefix`}
      />

      <PresetTextField
        label="dashboard.widget.indicator.field.suffix"
        value={suffix}
        onChange={(v) => onChange('suffix', v)}
        testId={`${testIdPrefix}-suffix`}
        testIdPrefix={`${testIdPrefix}-suffix`}
      />

      <div className="mb-3">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            data-testid={`${testIdPrefix}-use-millions`}
            id={`${testIdPrefix}-use-millions`}
            checked={useMillions}
            onChange={(e) => onChange('useMillions', e.target.checked)}
          />
          <label className="form-check-label" htmlFor={`${testIdPrefix}-use-millions`}>
            {t('dashboard.widget.indicator.field.useMillions')}
          </label>
        </div>
      </div>

      {useMillions && (
        <div className="mb-3">
          <label className="form-label">{t('dashboard.widget.indicator.field.millionsFrom')}</label>
          <input
            type="number"
            className="form-control"
            data-testid={`${testIdPrefix}-millions-from`}
            value={numberValue(millionsFrom)}
            onChange={(e) => handleNumberChange('millionsFrom', e.target.value)}
          />
        </div>
      )}

      <div className="mb-3">
        <label className="form-label">{t('dashboard.widget.indicator.field.decimalPlaces')}</label>
        <input
          type="number"
          className="form-control"
          data-testid={`${testIdPrefix}-decimal-places`}
          value={numberValue(decimalPlaces)}
          onChange={(e) => handleNumberChange('decimalPlaces', e.target.value)}
        />
      </div>
    </div>
  );
}
